import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const WITHOUT = ['Spending hours preparing adapted materials', 'Searching online for new activities', 'Keeping resources scattered everywhere', 'Rebuilding activities for different needs', 'Creating every visual support from scratch', 'Struggling to organize planning and progress', 'Starting the day without the right resources'];
const WITH = ['Have adapted materials ready in minutes', 'Access visual supports and practical activities', 'Find your teaching resources in one place', 'Differentiate activities faster', 'Build structured classroom routines', 'Track meaningful progress professionally', 'Walk into class prepared'];
export function Comparison() {
  return <section aria-labelledby="comparison-title" className="w-full bg-white px-3 py-7 sm:px-5" data-id="element-33" data-mp="28vx81gb9vi8p">
      <div className="mx-auto max-w-3xl" data-id="element-34" data-mp="9kxjqq707cgr">
        <h2 id="comparison-title" className="text-center font-head text-xl uppercase leading-[0.98] text-ink sm:text-3xl" data-id="element-35" data-mp="9lyu0sg73uxf">
          Your next lesson can begin with another blank page...
          <span className="mt-0.5 block text-mustard" data-id="element-36" data-mp="1m20i8hhvkz9a">Or you can have a complete system ready.</span>
        </h2>

        <div className="mt-4 grid gap-2 md:grid-cols-2" data-id="element-37" data-mp="1h85yxf66mmaq">
          <div className="rounded-xl border border-coral/30 bg-coral/5 p-3" data-id="element-38" data-mp="1d96wc17xb1mg">
            <h3 className="font-head text-sm uppercase tracking-wide text-coral sm:text-base" data-id="element-39" data-mp="18a3q4dg7ipcw">
              Without Special Education Teacher Pro™
            </h3>
            <ul className="mt-1.5 space-y-1" data-id="element-40" data-mp="24x8pjcisnphd">
              {WITHOUT.map(item => <li key={item} className="flex items-start gap-1.5 text-[13px] leading-snug text-body" data-id="element-41" data-mp="20yhowvf4dppi">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-coral" aria-hidden="true" data-id="element-42" data-mp="1vx24n5krnn86" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-xl border border-cta/30 bg-cta/5 p-3" data-id="element-43" data-mp="kkrhbeoskjb4">
            <h3 className="font-head text-sm uppercase tracking-wide text-cta-dark sm:text-base" data-id="element-44" data-mp="fk3vr8jc0uoa">
              With Special Education Teacher Pro™
            </h3>
            <ul className="mt-1.5 space-y-1" data-id="element-45" data-mp="gzpuiwxfkg56">
              {WITH.map(item => <li key={item} className="flex items-start gap-1.5 text-[13px] leading-snug text-body" data-id="element-46" data-mp="lzlxqtyb03jo">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-cta" aria-hidden="true" data-id="element-47" data-mp="80m7jhv57gle" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}